import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { getControl, getFormArray } from '@shared/helpers/form.helper';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyElIrregSanabiliEntity, MyVerbale } from '../../../models/interfaces/revisione.interface';
import { getConclusioniControl } from '../validators/helpers/conclusioni-form.helper';
import { cloneDeep } from 'lodash-es';
import { calcolaDataScadenzaAccertamento, calcolaDataScadenzaDiffida } from './helpers/conclusioni-listeners.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

export const setConclusioniIrregolaritaListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_CkIrregSanabili(form, store);
    my_DescIrregSanabili(form, store);
};

const my_CkIrregSanabili = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getConclusioniControl(form, 'my_CkIrregSanabili');

    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe((my_CkIrregSanabili) => {
        const visibWarning = my_CkIrregSanabili === '1' ? '1' : '0';

        const warningArray = getFormArray(form, 'my_Warning.my_ElWarning');

        if (warningArray?.controls?.[2]) {
            getControl(warningArray.controls[2] as FormGroup, 'my_VisibWarning')?.patchValue(visibWarning, { emitEvent: false });
        }

        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);

            if (myVerbaleClone.my_Warning.my_ElWarning[2]) {
                myVerbaleClone.my_Warning.my_ElWarning[2].my_VisibWarning = visibWarning;
            }

            return myVerbaleClone;
        });

        calcolaDataScadenzaAccertamento(form, store);
        calcolaDataScadenzaDiffida(form, store);
    });
};

const my_DescIrregSanabili = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getConclusioniControl(form, 'my_IrregSanabili.my_ElIrregSanabili');
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe((my_ElIrregSanabili: MyElIrregSanabiliEntity[]) => {
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);

            myVerbaleClone.my_SezioneII__Accertamento.my_RisultanzeAccert.my_ElRisultanzeAccert = my_ElIrregSanabili
                .filter((irregSanabili) => !isNilOrEmpty(irregSanabili.my_DescIrregSanabili))
                .map((irregSanabili) => ({
                    my_DescRisultAccert: irregSanabili.my_DescIrregSanabili,
                    my_CommRisultAccert: '',
                }));

            return myVerbaleClone;
        });
    });
};
